import { styled, Skeleton, Typography, Hidden } from '@ori-ui/mui';
import type { FC } from 'react';

import { FourthColumn } from '../FourthColumn';
import { Highlight } from '../Highlight';
import { HighlightGrid } from '../HighlightGrid';
import { LinkColumn, MobileLinkColumn } from './LinkColumn';
import { MobileAppsColumn } from './MobileAppsColumn';

const UnifiedSkeleton = styled(Skeleton)({
  transform: 'none',
});

const Root = styled('div')({});

const CenteredRoot = styled('div')({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  background: 'white',
});

const CopyrightRoot = styled(CenteredRoot)({
  height: '40px',
  paddingBottom: '30px',
});

const FollowUsRoot = styled(CenteredRoot)({
  height: '165px',
  flexFlow: 'column',
});

const SocialIconsSkeleton = styled(UnifiedSkeleton)(({ theme }) => ({
  marginTop: theme.spacing(2),
}));

const LinksRoot = styled('div')(({ theme }) => ({
  width: '100%',
  display: 'grid',
  rowGap: '12px',
  [theme.breakpoints.up('sm')]: {
    gridAutoFlow: 'column',
    gridAutoColumns: 'minmax(150px, 1fr)',
    justifyContent: 'center',
    justifyItems: 'center',
    columnGap: theme.spacing(3),
  },
}));

const SubscribeBannerRoot = styled(CenteredRoot)({
  height: 70,
});

/**
 * Footer app skeleton for when the footer is no longer served via SSR but rendered only via CSR
 */
export const FooterAppSkeleton: FC = () => (
  <Root>
    <FollowUsRoot>
      <Typography variant="h6">
        <UnifiedSkeleton width={85} />
      </Typography>
      <SocialIconsSkeleton
        width={200}
        height={34}
      />
    </FollowUsRoot>
    <SubscribeBannerRoot>
      <UnifiedSkeleton
        height={27}
        width={400}
      />
    </SubscribeBannerRoot>
    <Highlight>
      <HighlightGrid>
        <LinksRoot>
          <Hidden smUp>
            <MobileLinkColumn />
            <MobileLinkColumn />
            <MobileLinkColumn />
          </Hidden>
          <Hidden smDown>
            <LinkColumn />
            <LinkColumn />
            <LinkColumn />
          </Hidden>
        </LinksRoot>
        <FourthColumn>
          <MobileAppsColumn />
        </FourthColumn>
      </HighlightGrid>
    </Highlight>
    <Hidden mdUp>
      <MobileAppsColumn />
    </Hidden>
    <CopyrightRoot>
      <UnifiedSkeleton
        width={340}
        height={40}
      />
    </CopyrightRoot>
  </Root>
);
